import React from "react";
import { Container } from "react-bootstrap";
import physusLogo from "../../../../assets/images/logo/physusLogo.png";

const Footer = (props) => {
  const urlParams = new URLSearchParams(window.location.search);
  const mode = urlParams.get("dark");
  if (mode !== null) {
    document.body.classList = "";
    switch (mode) {
      case "true":
        document.body.classList = "dark";
        break;
      case "false":
        document.body.classList = "";
        break;
      default:
        document.body.classList = "";
        break;
    }
  }

  return (
    <footer className="iq-footer bg-white px-3 px-md-4 py-1 mt-3">
      <Container
        fluid
        className="d-flex flex-column flex-md-row align-items-center justify-content-center gap-2 gap-md-5 text-center"
      >
        <p className="mb-0 fw-medium small">
          Organized by IHFC (I-Hub Foundation for Cobotics), IIT Delhi
        </p>

        <span className="d-none d-md-inline text-muted">|</span>

        <img
          src={physusLogo}
          alt="Physus Logo"
          style={{ height: "clamp(40px, 10vw, 55px)", width: "clamp(40px, 10vw, 55px)", objectFit: "contain" }}
        />
      </Container>
    </footer>
  );
};

export default Footer;